<!-- Notification List -->
<section #myDrop="ngbDropdown" placement="bottom-right" ngbDropdown class="notification" (openChange)="onDropdownOpen($event)">
  @if(isMobile){
      <i class="fa-solid fa-bell profile-notification-icon" (click)="openMenuForMobile = true" style="position: relative">
    <span style="position: absolute; top: -5px; right: -10px; font-size: 11px; font-weight: bold" *ngIf="notificationList.length && !showingAll">{{ notificationList.length }}</span>
    <i class="fa fa-circle notification-icon" data-no-icon="true" aria-hidden="true"></i>
  </i>
  }@else {
  <i class="fa-solid fa-bell profile-notification-icon" ngbDropdownToggle style="position: relative">
    <span style="position: absolute; top: -5px; right: -10px; font-size: 11px; font-weight: bold" *ngIf="notificationList.length && !showingAll">{{ notificationList.length }}</span>
    <i class="fa fa-circle notification-icon" data-no-icon="true" aria-hidden="true"></i>
  </i>
  }

  @if(isMobile){ 
  <div class="notification-menu-mobile" [class.active]="openMenuForMobile">
    <div class="notification-menu-mobile__header">
      <div><i class="fa fa-bell" aria-hidden="true"></i> Notification</div>
      <i class="fa-solid fa-xmark" (click)="$event.stopPropagation(); openMenuForMobile = false; clearParentZIndex(); makeAllNotifsSeen();"></i>
    </div>


    <div class="notification-menu-mobile__body">
      @if(!currentNotificationForMobile && notificationList?.length){
        <ng-container *ngFor="let i of notificationList">
          @if(i.type == 'booking'){
          <notification-booking [data]="i"></notification-booking>
          }@else{
          <section ngbDropdownItem class="notification-item" (click)="openNotification(notification, i)">
            <div class="row" style="background-color: transparent; position: relative;">
              <div class="col-9 p-2" style="position: static !important;">
                <!-- <h3 class="notification-item-header">{{ i.type == "quest" ? "Daily Challenges" : "Notification" }}</h3> -->
                <span *ngIf="!i.isRead" class="notification-close" title="close" (click)="closeNotification(i)"><i class="fa fa-times" aria-hidden="true"></i></span>
                <p class="notification-item-message">{{ i.message }}</p>
                <img src="../../../assets/images/gold-coin.png" style="width: 2.25rem;
                height: 2.25rem;
                position: absolute;
                top: 30%;
                right: 1em" *ngIf="i.type=='coin'"/>
                <div class="notification-item-time mt-3">{{ i.createdAt | date : "dd MMM hh:mm a" | uppercase }}</div>
                <span *ngIf="i.type == 'quest'" class="quest-tag" style="font-weight: bold">{{ status[i.quest.status] | titlecase }}</span>
              </div>
            </div>
          </section>
          }
        </ng-container>

      }@else if(currentNotificationForMobile){

        @if(currentNotificationForMobile.type == 'booking'){
          <notification-booking [data]="currentNotificationForMobile"></notification-booking>
          }@else{
          <section ngbDropdownItem class="notification-item">
            <div class="row" style="background-color: transparent; position: relative;">
              <div class="col-9 p-2" style="position: static !important;">
                <span *ngIf="!currentNotificationForMobile.isRead" class="notification-close" title="close" (click)="closeNotification(currentNotificationForMobile)"><i class="fa fa-times" aria-hidden="true"></i></span>
                <p class="notification-item-message">{{ currentNotificationForMobile.message }}</p>
                <img src="../../../assets/images/gold-coin.png" style="width: 2.25rem;
                height: 2.25rem;
                position: absolute;
                top: 30%;
                right: 1em" *ngIf="currentNotificationForMobile.type=='coin'"/>
                <div class="notification-item-time mt-3" *ngIf="currentNotificationForMobile.createdAt">{{ currentNotificationForMobile.createdAt | date : "dd MMM hh:mm a" | uppercase }}</div>
                <span *ngIf="currentNotificationForMobile.type == 'quest'" class="quest-tag" style="font-weight: bold">{{ status[currentNotificationForMobile.quest.status] | titlecase }}</span>
              </div>
            </div>
          </section>
          }

      }
  

      <section *ngIf="!notificationList || notificationList.length == 0">
        <div class="no-notificate">No new Notifications</div>
      </section>
    </div>
    <div class="position-absolute" style="right: .5em; bottom: .5em;">
      <button class="see-all-btn" (click)="showAllNotifications()"  *ngIf="allNotifications.length && !showingAll">See all</button>
      <button class="see-all-btn" (click)="showRecentNotifications()" *ngIf="showingAll">See recent only</button>
    </div>
  </div>
   } @else {
  <div ngbDropdownMenu class="notification-menu">
    <div class="notification-menu__header">
      <div><i class="fa fa-bell" aria-hidden="true"></i> Notification</div>
      <i class="fa-solid fa-xmark" (click)="$event.stopPropagation(); myDrop.close()"></i>
    </div>

    <div class="notification-menu__body">
      <ng-container *ngFor="let i of notificationList">
        @if(i.type == 'booking'){
        <notification-booking [data]="i"></notification-booking>
        }@else{
        <section ngbDropdownItem class="notification-item" (click)="openNotification(notification, i)">
          <div class="row" style="background-color: transparent; position: relative;">
            <div class="col-9 p-2" style="position: static !important;">
              <!-- <h3 class="notification-item-header">{{ i.type == "quest" ? "Daily Challenges" : "Notification" }}</h3> -->
              <span *ngIf="!i.isRead" class="notification-close" title="close" (click)="closeNotification(i)"><i class="fa fa-times" aria-hidden="true"></i></span>
              <p class="notification-item-message">{{ i.message }}</p>
              <div class="notification-item-time mt-3">{{ i.createdAt | date : "dd MMM hh:mm a" | uppercase }}</div>
              <span *ngIf="i.type == 'quest'" class="quest-tag" style="font-weight: bold">{{ status[i.quest.status] | titlecase }}</span>
              <img src="../../../assets/images/gold-coin.png" style="width: 2.25rem;
              height: 2.25rem;
              position: absolute;
              top: 30%;
              right: 1em;
            
            " *ngIf="i.type=='coin'"/>
            </div>
          </div>
        </section>
        }
      </ng-container>

      <section *ngIf="!notificationList || notificationList.length == 0">
        <div class="no-notificate">No new Notifications</div>
      </section>
    </div>
    <div  class="position-absolute" style="right: .5em; bottom: .5em;font-size: .8rem">
      <button class="see-all-btn" (click)="showAllNotifications()" *ngIf="allNotifications.length && !showingAll">See all</button>
      <button class="see-all-btn" (click)="showRecentNotifications()" *ngIf="showingAll">See recent only</button>
    </div>
  </div>
  }
</section>
<!-- Notification List -->

<!-- Notification Audio -->
<audio #clickSound src="../../../../assets/sounds/notification.webm"></audio>
<audio #kachiingSound src="../../../../assets/sounds/kachiing.mp3"></audio>
<!-- Notification Audio -->

<!-- Notification  -->
<div class="notification-popup" [class.active]="notificationPopup" (click)="popupClick()">
  <i class="fa-solid fa-xmark" (click)="notificationPopup = false"></i>
  <div class="notification-popup__body">
    <div class="name">{{ data?.title }}</div>
    <div class="desc">{{ data?.description }}</div>
  </div>
</div>
<!-- Notification  -->

<!-- Notification popup -->
<ng-template #notification let-modal>
  <div class="modal-body">
    <div class="modal-header flex justify-content-between p-0 pb-2">
      <h2 class="flex-1">
        <i class="fa fa-bell" aria-hidden="true" style="color: #6d36b7"></i>
        {{ selectedNotification.type + (selectedNotification.quest?.status == 1 ? " completed" : "") | titlecase }}
      </h2>
      <img loading="lazy" class="flex-1" src="../../../../assets/images/close-icon.svg" alt="img" (click)="modal.dismiss('Cross click')" />
    </div>

    <section>
      <div style="width: 100%">
        <div class="card-body">
          <span class="quest" style="height: 20rem">
            <div id="carouselExampleIndicators" class="carousel slide" data-ride="carousel" data-interval="2500">
              <ol class="carousel-indicators">
                <li data-target="#carouselExampleIndicators" data-slide-to="" class="carousel_slider_indicator active"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="" class="carousel_slider_indicator"></li>
                <li data-target="#carouselExampleIndicators" data-slide-to="" class="carousel_slider_indicator"></li>
              </ol>
              <div class="carousel-inner"></div>
              <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="sr-only">Previous</span>
              </a>
              <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="sr-only">Next</span>
              </a>
            </div>
          </span>
          <p class="text-center text-wrap pt-2">
            {{ selectedNotification.message }}
          </p>
        </div>
        <div class="modal-footer flex justify-content-center" *ngIf="selectedNotification.quest?.status == 0">
          <button type="button" class="btn btn-primary mr-3" (click)="accept(3)"><i class="fa fa-thumbs-up" aria-hidden="true"></i>Accept</button>
          <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="modal.dismiss('Cross click')">Close</button>
        </div>
        <div class="modal-footer flex justify-content-center" *ngIf="selectedNotification.quest?.status == 1">
          <button type="button" class="btn btn-outline-secondary" data-dismiss="modal" (click)="closeNotification(selectedNotification); modal.dismiss('Cross click')">Close</button>
        </div>
      </div>
    </section>
  </div>
</ng-template>
<!-- Notification popup -->
